import { getField, updateField } from 'vuex-map-fields';

const defaultReporterFormData = () => {
    return {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        category: null,
        consents: {},
        corpo_name: '',
        corpo_street: '',
        corpo_building_number: '',
        corpo_flat_number: '',
        corpo_postal_code: '',
        corpo_city: '',
        corpo_province: null,
        corpo_tax_id: ''
    };
};

export default {
    namespaced: true,
    state: {
        reporterFormData: defaultReporterFormData()
    },
    getters: {
        getField,
        getReporterFormData (state) {
            return state.reporterFormData;
        }
    },
    mutations: {
        updateField,
        clearFormData (state) {
            state.reporterFormData = defaultReporterFormData();
        }
    }
};
